import { Component } from '@angular/core';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ImportConfigurationManualImportFormType } from './configuration-form-manual-import-form-type';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-configuration-form-manual-import',
    templateUrl: './configuration-form-manual-import.component.html',
    styleUrls: ['./configuration-form-manual-import.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, TranslateModule]
})
export class ConfigurationFormManualImportComponent {
  
  public get configurationFormManualImport(): FormGroup<ImportConfigurationManualImportFormType> {
    return this.formsCoordinationService.configurationFormManualImport;
  }

  constructor(private formsCoordinationService: ImportConfigurationEditFormsCoordinatorService) { }
}
